import React, { Component } from 'react';
import Input from '../../components/Form/Input/Input';
import Button from '../../components/Button/Button';
import Auth from '../Auth/Auth';
import Post from '../../components/Feed/Post/Post';
import Loader from '../../components/Loader/Loader';
import ImageUrlGenerator from './GetPublicUrlOfImages';

class EmployeesPolicies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitBtn: false,
            policyForm: {
                name: {
                    value: '',
                    valid: false,
                    validators: [],
                },
                url: {
                    value: null,
                    valid: true,
                    validators: [],
                },
                date: {
                    value: '',
                    valid: false,
                    validators: [],
                },
            },
            formShow: false,
            posts: [],
            postsLoading: false,
            editPostBtn: false,
            editPostId: null,
        };
    }

    inputChangeHandler = (input, value) => {
        this.setState((prevState) => {
            let isValid = true;
            for (const validator of prevState.policyForm[input].validators) {
                isValid = isValid && validator(value);
            }
            const updatedForm = {
                ...prevState.policyForm,
                [input]: {
                    ...prevState.policyForm[input],
                    valid: isValid,
                    value: value,
                },
            };
            let formIsValid = true;
            for (const inputName in updatedForm) {
                formIsValid = formIsValid && updatedForm[inputName].valid;
            }
            return {
                policyForm: updatedForm,
                formIsValid: formIsValid,
            };
        });
    };

    toggleForm = () => {
        this.setNullAllInputField();
        this.setState((prevState) => ({
            formShow: !prevState.formShow,
        }));
    };

    setNullAllInputField = () => {
        this.setState((prevState) => ({
            policyForm: {
                ...prevState.policyForm,
                name: { ...prevState.policyForm.name, value: '' },
                url: { ...prevState.policyForm.url, value: null },
                date: { ...prevState.policyForm.date, value: '' },
            },
        }));
    };

    onPolicySubmit = (event) => {
        event.preventDefault();
        const { name, url, date } = this.state.policyForm;

        if (!name.value.trim() || !date.value) {
            alert("Please fill in all required fields.");
            return;
        }

        const requestData = {
            updatedBy: localStorage.getItem("userId"), 
            createdBy: localStorage.getItem("userId"),
            name: name.value,
            url: url.value,
            date: new Date(date.value).toISOString(),
        };


        const endpoint = `${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/policiesLink`;
        if (this.state.editPostBtn) {
            fetch(`${endpoint}/${this.state.editPostId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            })
                .then(res => res.json())
                .then(data => {
                    this.toggleForm();
                    this.fetchPosts();
                    this.setNullAllInputField();
                    this.setState({
                        editPostBtn: false,
                        editPostId: null,
                    });
                })
                .catch(err => {
                    console.error('Error updating policy:', err);
                });
        } else {
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            })
                .then(res => {
                    if (res.status === 500) {
                        // alert("Internal server error");
                        throw new Error('Server error');
                    }
                    return res.json();
                })
                .then(data => {
                    this.toggleForm();
                    this.fetchPosts();
                    this.setNullAllInputField();
                })
                .catch(err => {
                    console.error('Error creating policy:', err);
                });
        }
    };

    fetchPosts = () => {
        this.setState({ postsLoading: true });
        fetch(`${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/policiesLink`)
            .then((res) => res.json())
            .then((resData) => {
                this.setState({ posts: resData, postsLoading: false });
            })
            .catch((err) => {
                console.error('Error fetching policies:', err);
                this.setState({ postsLoading: false });
            });
    };

    deletePostHandler = (postId) => {
        this.setState({ postsLoading: true });
        fetch(`${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/policiesLink/${postId}`, {
            method: 'DELETE',
            headers: {
                Authorization: 'Bearer ' + this.props.token,
            },
        })
            .then((res) => {
                if (res.status !== 200 && res.status !== 201) {
                    throw new Error('Deleting a policy failed!');
                }
                this.fetchPosts();
            })
            .catch((err) => {
                console.error('Error deleting policy:', err);
                this.setState({ postsLoading: false });
            });
    };

    fetchSinglePost = (postId) => {
        this.setState({ postsLoading: true });
        fetch(`${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/policiesLink/${postId}`)
            .then(res => {
                if (res.status !== 200) {
                    throw new Error('Failed to fetch policy data.');
                }
                return res.json();
            })
            .then(resData => {
                this.setState(prevState => ({
                    policyForm: {
                        ...prevState.policyForm,
                        name: { ...prevState.policyForm.name, value: resData.name },
                        url: { ...prevState.policyForm.url, value: resData.url },
                        date: { ...prevState.policyForm.date, value: resData.date.split('T')[0] },
                    },
                }));
            })
            .catch(error => {
                console.error('Error fetching policy data:', error);
            })
            .finally(() => {
                this.setState({ postsLoading: false });
            });
    };

    editPost = postId => {
        this.setState({
            editPostBtn: true,
            editPostId: postId
        }, () => {
            this.fetchSinglePost(postId);
            this.toggleForm();
        });
    };
    componentDidMount() {
        this.fetchPosts();
    }
    render() {
        return (
            <div className="main-div-login">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '1rem 0' }}>
                    <button onClick={this.toggleForm} className='buttonCreatePost'>
                        {this.state.formShow ? 'Close Policy Form' : 'Create New Policy'}
                    </button>
                </div>
                {this.state.formShow && (
                    <Auth>
                        <form onSubmit={this.onPolicySubmit}>
                            <Input
                                id="name"
                                label="Policy Name"
                                type="text"
                                control="input"
                                onChange={this.inputChangeHandler}
                                value={this.state.policyForm['name'].value}
                                valid={this.state.policyForm['name'].valid}
                            />
                            <Input
                                id="url"
                                label="URL (Optional)"
                                type="url"
                                control="input"
                                onChange={this.inputChangeHandler}
                                value={this.state.policyForm['url'].value || ''}
                                valid={this.state.policyForm['url'].valid}
                            />
                            <Input
                                id="date"
                                label="Effective Date"
                                type="date"
                                control="input"
                                onChange={this.inputChangeHandler}
                                value={this.state.policyForm['date'].value}
                                valid={this.state.policyForm['date'].valid}
                            />
                            {this.state.editPostBtn ? (
                                <Button design="raised" type="submit" loading={this.props.loading}>
                                    Update Policy
                                </Button>
                            ) : (
                                <Button design="raised" type="submit" loading={this.props.loading}>
                                    Create Policy
                                </Button>
                            )}
                        </form>
                    </Auth>
                )}
                <Auth>
                    {this.state.postsLoading && <Loader />}
                    {this.state.posts.length <= 0 && !this.state.postsLoading ? (
                        <p style={{ textAlign: 'center' }}>No policies found.</p>
                    ) : null}
                    {this.state.posts.map((post) => (
                        <Post
                            key={post.id}
                            id={post.id}
                            title={post.name}
                            content={`Date: ${new Date(post.date).toLocaleDateString()}${post.url ? ' | URL: ' + post.url : ''}`}
                            onStartEdit={() => this.editPost(post.id)}
                            onDelete={() => this.deletePostHandler(post.id)}
                        />
                    ))}
                </Auth>
            </div>
        );
    }
}

export default EmployeesPolicies;